import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api } from "../lib/api";
import { CompliancePanel } from "./CompliancePanel";

const Card = ({ label, value, testId }) => (
  <div className="border border-zinc-900 bg-ink-surface p-6" data-testid={testId}>
    <p className="font-display text-4xl font-bold text-white">{value}</p>
    <p className="mt-2 text-[0.65rem] uppercase tracking-[0.16em] text-zinc-500">{label}</p>
  </div>
);

export default function Dashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/analytics/overview").then((r) => setData(r.data));
  }, []);

  if (!data) return <p className="text-zinc-600" data-testid="dashboard-loading">Loading…</p>;

  return (
    <div data-testid="admin-dashboard">
      <p className="overline">Overview</p>
      <h1 className="display-2 mt-4">Dashboard</h1>

      <div className="mt-10 grid gap-px border border-zinc-800 bg-zinc-800 sm:grid-cols-2 lg:grid-cols-4">
        <Card label="Page views" value={data.page_views} testId="stat-page-views" />
        <Card label="Players" value={data.players} testId="stat-players" />
        <Card label="Stories" value={data.news} testId="stat-news" />
        <Card label="Submissions" value={data.submissions} testId="stat-submissions" />
        <Card label="Newsletter signups" value={data.newsletter} testId="stat-newsletter" />
      </div>

      <CompliancePanel />

      <div className="mt-12 border border-zinc-900 bg-ink-surface p-7">
        <p className="overline">Most viewed players</p>
        {data.top_players.length === 0 ? (
          <p className="body-copy mt-4">No player views recorded yet.</p>
        ) : (
          <div className="mt-6 h-[280px] min-h-[280px] w-full min-w-[280px]" data-testid="top-players-chart">
            <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 600, height: 280 }}>
              <BarChart data={data.top_players}>
                <CartesianGrid stroke="#1f1f1f" vertical={false} />
                <XAxis dataKey="name" tick={{ fill: "#71717a", fontSize: 11 }} interval={0} height={60} angle={-20} textAnchor="end" />
                <YAxis tick={{ fill: "#71717a", fontSize: 11 }} allowDecimals={false} />
                <Tooltip cursor={{ fill: "#18181b" }} contentStyle={{ background: "#111", border: "1px solid #222", color: "#fff" }} />
                <Bar dataKey="views" fill="#E32118" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}
